<template>
  <div>
    <div class="row">
      <div :class="inputTypeInfo['cust_kind']['class']">
        <label class="desc_title" for="cust_kind">客戶別</label>
        <select
          name="cust_kind"
          class="form-select custom-select"
          style="width: 100%"
          :value="findValue('cust_kind')"
        >
          <option value=""></option>
          <option value="n">自然人</option>
          <option value="j">法人</option>
        </select>
      </div>
      <div :class="inputTypeInfo['cust_name']['class']">
        <label class="desc_title" for="cust_name"
          >客戶名稱 <span class="warning_text">*</span></label
        >
        <input
          type="text"
          class="form-control"
          name="cust_name"
          placeholder=""
          :value="findValue('cust_name')"
        />
      </div>
      <div :class="inputTypeInfo['cust_abbreviate']['class']">
        <label class="desc_title" for="cust_abbreviate">客戶簡稱</label>
        <input
          type="text"
          class="form-control"
          name="cust_abbreviate"
          placeholder=""
          :value="findValue('cust_abbreviate')"
        />
      </div>
      <div :class="inputTypeInfo['gender']['class']">
        <label class="desc_title" for="gender">性別</label>
        <select
          name="gender"
          class="form-select custom-select"
          style="width: 100%"
          :value="findValue('gender')"
        >
          <option value=""></option>
          <option value="m">男</option>
          <option value="f">女</option>
        </select>
      </div>
    </div>

    <!-- 2nd row -->
    <div class="row">
      <div :class="inputTypeInfo['identify']['class']">
        <label class="desc_title" for="identify">身份證號</label>
        <input
          type="text"
          class="form-control"
          name="identify"
          placeholder=""
          :value="findValue('identify')"
        />
      </div>
      <div :class="inputTypeInfo['passport']['class']">
        <label class="desc_title" for="passport">護照號碼</label>
        <input
          type="text"
          class="form-control"
          name="passport"
          placeholder=""
          :value="findValue('passport')"
        />
      </div>
    </div>
    <!-- 3rd row -->
    <div class="row">
      <div :class="inputTypeInfo['add_household']['class']">
        <label class="desc_title" for="add_household">戶籍地址</label>
        <input
          type="text"
          class="form-control"
          name="add_household"
          placeholder=""
          :value="findValue('add_household')"
        />
      </div>
      <div :class="inputTypeInfo['add_comm']['class']">
        <label class="desc_title" for="add_comm">通訊地址</label>
        <input
          type="text"
          class="form-control"
          name="add_comm"
          placeholder=""
          :value="findValue('add_comm')"
        />
      </div>
    </div>
    <!-- 4th row -->
    <div class="row">
      <div :class="inputTypeInfo['phone_no']['class']">
        <label class="desc_title" for="phone_no">電話號碼</label>
        <input
          type="text"
          class="form-control"
          name="phone_no"
          placeholder=""
          :value="findValue('phone_no')"
        />
      </div>
      <div :class="inputTypeInfo['mobile_no']['class']">
        <label class="desc_title" for="mobile_no"
          >行動電話 <span class="warning_text">*</span></label
        >
        <input
          type="text"
          class="form-control"
          name="mobile_no"
          placeholder=""
          :value="findValue('mobile_no')"
        />
      </div>
    </div>
    <!-- 5th row -->
    <div class="row">
      <div :class="inputTypeInfo['email']['class']">
        <label class="desc_title" for="email">電子郵件</label>
        <input
          type="text"
          class="form-control"
          name="email"
          placeholder=""
          :value="findValue('email')"
        />
      </div>
    </div>
    <!-- 6st row -->
    <div class="row">
      <div :class="inputTypeInfo['contact_name']['class']">
        <label class="desc_title" for="contact_name">聯絡人</label>
        <input
          type="text"
          class="form-control"
          name="contact_name"
          placeholder=""
          :value="findValue('contact_name')"
        />
      </div>
      <div :class="inputTypeInfo['rela_id']['class']">
        <label class="desc_title" for="rela_id">與客戶關係</label>
        <relation-select
          :page-search="pageSearch"
          :relation-url="relationUrl"
          :row="row"
          :options="options"
          :data-type-content-search="dataTypeContentSearch"
          :relationship-data="relationshipData"
          :voyager-generic-none="voyagerGenericNone"
          :old-input="oldInput"
        />
      </div>
      <div :class="inputTypeInfo['contact_phone']['class']">
        <label class="desc_title" for="contact_phone">電話號碼</label>
        <input
          type="text"
          class="form-control"
          name="contact_phone"
          placeholder=""
          :value="findValue('contact_phone')"
        />
      </div>
      <div :class="inputTypeInfo['contact_mobile']['class']">
        <label class="desc_title" for="contact_mobile">行動電話</label>
        <input
          type="text"
          class="form-control"
          name="contact_mobile"
          placeholder=""
          :value="findValue('contact_mobile')"
        />
      </div>
    </div>
    <!-- 6th row -->
    <div class="row">
      <div :class="inputTypeInfo['remark']['class']">
        <label class="desc_title" for="remark">備註</label>
        <textarea
          class="form-control"
          rows="2"
          name="remark"
          :value="findValue('remark')"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    pageSearch: {
      type: Object,
      default: () => ({}),
    },
    inputTypeInfo: {
      type: Object,
      default: () => ({}),
    },
    oldInput: {
      type: Object,
      default: () => ({}),
    },
    dataTypeContentSearch: {
      type: Object,
      default: () => ({}),
    },
    voyagerGenericNone: {
      type: String,
      default: "",
    },
    relationUrl: {
      type: String,
      default: "",
    },
    row: {
      type: Object,
      default: () => ({}),
    },
    options: {
      type: Object,
      default: () => ({}),
    },
    relationshipData: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    findValue(key) {
      if (this.oldInput[key]) {
        return this.oldInput[key];
      }

      if (this.pageSearch[key]) {
        return this.pageSearch[key];
      }
      return "";
    },
  },
};
</script>
